var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#848484",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.325 11.8087H27.5125H24.7C23.8 11.8087 23.8 13.4783 24.7 13.4783H26.8375V15.7044H22.9562V14.4522C22.9562 12.9913 22 11.8087 20.8188 11.8087H14.1812C13 11.8087 12.0437 12.9913 12.0437 14.4522V15.7044H8.1625V13.4783H10.3C11.2 13.4783 11.2 11.8087 10.3 11.8087H7.4875H4.675C3.775 11.8087 3.775 13.4783 4.675 13.4783H6.8125V15.7044H6.08125C5.18125 15.7044 5.18125 17.3739 6.08125 17.3739H12.2125C12.3812 17.9305 12.775 18.4174 13.1687 18.6957L10.75 20.8522C10.5812 20.9913 10.4688 21.2 10.4688 21.4783V25.3739C10.4688 26.487 11.8187 26.487 11.8187 25.3739V21.8957L14.0125 20.0174L14.4625 21.3392C14.5188 21.6174 14.8 21.8261 15.0812 21.8261H19.9187C20.2 21.8261 20.4812 21.6174 20.5375 21.3392L20.9875 20.0174L23.1812 21.8957V25.3739C23.1812 26.487 24.5312 26.487 24.5312 25.3739V21.4783C24.5312 21.2 24.4187 20.9913 24.25 20.8522L21.8312 18.6957C22.225 18.4174 22.6187 17.9305 22.7875 17.3739H28.9187C29.8187 17.3739 29.8187 15.7044 28.9187 15.7044H28.1875V13.4783H30.325C31.225 13.4783 31.225 11.8087 30.325 11.8087ZM19.4688 20.2261H15.5312L15.1375 18.9739H19.8625L19.4688 20.2261ZM21.6062 16.3305C21.6062 16.887 21.2687 17.3044 20.8188 17.3044H14.1812C13.7312 17.3044 13.3938 16.887 13.3938 16.3305V14.4522C13.3938 13.8957 13.7312 13.4783 14.1812 13.4783H20.8188C21.2687 13.4783 21.6062 13.8957 21.6062 14.4522V16.3305Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/drone.9742ee7ef8c8f43e4c8d5aa3fa47cdc0.svg";
export { ForwardRef as ReactComponent };